import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import styled from '@mui/system/styled';

export const TextSignature = styled('input')({
  paddingBlock: '32px',
  border: 'none',
  fontSize: '28px',
  lineHeight: '32px',
  background: 'rgba(0, 0, 0, 0.04)',
  textAlign: 'center',
  fontFamily: 'Great Vibes',
});

export const SignatureImage = styled('img')({
  height: '52px',
  objectFit: 'cover',
  objectPosition: 'center',
});

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  backgroundColor: '#F5F5F5',
  borderRadius: 50,
  padding: 6,
  gap: 4,
  width: 'fit-content',
  '& .Mui-selected': {
    color: '#4E48FA !important',
    boxShadow: '0px 2px 2px 0px #00000014',
    backgroundColor: '#ffffff !important',
  },
});
export const StyledToggleButton = styled(ToggleButton)({
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '14px',
  padding: '8px 14px',
  borderRadius: '50px !important',
  border: 'none',
  color: '#000',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
});
